// extracted by mini-css-extract-plugin
export default {"container":"ErrorNotification_container__XvG-R"};